import { useMemo } from "react";
import { useAppContext } from "../Context/AppContext";
import { isLoggedIn } from "../auth/authStorage";
import { isUnpaidExplorerUser } from "../explorer/isUnpaidExplorerUser";
import { useGetExplorerMessagingLimit } from "../api/queries/useGetExplorerMessagingLimit";

/** Explorer-only: max 5 messages sent per week across all conversations.
 * Applies to unpaid users without Business/Executive/Early/Youth membership.
 */
export function useExplorerMessagingLimit() {
  const { objectId, user } = useAppContext();
  const userId = objectId ?? "";
  const profile = user?.user;

  const isExplorer = useMemo(
    () => isUnpaidExplorerUser(profile),
    [profile],
  );

  const { data: limitData, refetch: refetchLimit } = useGetExplorerMessagingLimit({
    userId,
    enabled: isLoggedIn() && !!userId && isExplorer,
  });

  const canSendMessage = useMemo(() => {
    if (!isExplorer) return true;
    return limitData?.canSendMessage !== false;
  }, [isExplorer, limitData?.canSendMessage]);

  return {
    isExplorer,
    canSendMessage,
    used: limitData?.used ?? 0,
    limit: limitData?.limit ?? 5,
    remaining: limitData?.remaining ?? 5,
    weekResetsUtc: limitData?.weekResetsUtc,
    refetchLimit,
  };
}
